import * as React from 'react';
import { useMediaQuery } from 'react-responsive';

import { Breakpoint, Color, IconName } from '../../enums';
import { Icon } from '../icon/icon.component';

import { ArrowButton, Button, Container, Header } from './sectionTitle.styled';
import { SectionTitleProps } from './sectionTitle.types';

export const SectionTitle: React.FC<SectionTitleProps> = (props: SectionTitleProps) => {
  const { header, buttonLabel, buttonAction, className }: SectionTitleProps = props;
  const isMobile: boolean = useMediaQuery({ query: Breakpoint.Mobile });

  return (
    <Container className={className}>
      <Header>{header}</Header>
      {!!buttonLabel && !!buttonAction && (
        isMobile ? (
          <ArrowButton onClick={buttonAction}>
            <Icon
              name={IconName.ArrowRightSideRight}
              color={Color.Gray500}
              size={20}
            />
          </ArrowButton>
        ) : (
          <Button onClick={buttonAction}>{buttonLabel}</Button>
        )
      )}
    </Container>
  );
};
